import { useWSQuery } from "@ws-react-query";
import { UseQueryOptions } from "@tanstack/react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getInsuranceCoverageMonitor } from "../../../services/api/insurance/monitor/getInsuranceCoverageMonitor";
import { InsuranceCoverageMonitor } from "../../../services/api/insurance/monitor/types";

export const QUERY_INSURANCE_COVERAGE_MONITOR =
  "QUERY_INSURANCE_COVERAGE_MONITOR";

export const useInsuranceCoverageMonitorQuery = (
  requestId: string,
  options?: UseQueryOptions<InsuranceCoverageMonitor, WSServiceError>
) => {
  return useWSQuery<InsuranceCoverageMonitor, WSServiceError>(
    [QUERY_INSURANCE_COVERAGE_MONITOR, requestId],
    () => getInsuranceCoverageMonitor(requestId),
    {
      enabled: !!requestId,
      ...options
    }
  );
};
